import React from 'react';
import clsx from 'clsx';
import { styled } from '@mui/material';

import classes from './apple-pay-button.module.css';

export type ApplePayButtonVariant = 'black' | 'white' | 'white-outline';

type ApplePayButtonProps = {
  variant?: ApplePayButtonVariant;
  onClick?(): void;
};

const StyledApplePayButton = styled('div', {
  shouldForwardProp: (prop) => prop !== 'variant',
})<ApplePayButtonProps>(({ variant }) => ({
  '-apple-pay-button-style': variant,
}));

export const ApplePayButton = (props: ApplePayButtonProps) => {
  const { variant = 'black', onClick } = props;

  return (
    <StyledApplePayButton
      className={clsx(classes.root, classes[variant])}
      aria-label="apple-pay-button"
      onClick={onClick}
      onKeyDown={onClick}
      role="button"
      tabIndex={0}
      variant={variant}
    />
  );
};
